"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configs_js_1 = require("../configs/configs.js");
const Path_1 = require("../Util/Path");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const ErrorCodes_1 = require("../Enum/ErrorCodes");
const TooManyValuationError_1 = require("../Error/TooManyValuationError");
class CustomerRepository {
    constructor(config, httpClient, customerTransformer, errorTransformer, customerMergePathcConverter) {
        this.config = config;
        this.httpClient = httpClient;
        this.customerToRequestTransformer = customerTransformer;
        this.errorTransformer = errorTransformer;
        this.customerMergePatchConverter = customerMergePathcConverter;
    }
    /**
     * @inheritDoc
     */
    static create(config, container) {
        return new this(config, container.get('http_client'), container.get('transformer.customer_to_data'), container.get('transformer.axios_to_error'), container.get('converter.customer_merge_patch'));
    }
    /**
     * Create new customer.
     *
     * @param {Customer} customer
     * @returns {Promise<Customer>}
     */
    create(customer) {
        const url = Path_1.default.route(configs_js_1.configs.endpoints.customer, {});
        return this.httpClient.post(url, this.customerToRequestTransformer.to(customer))
            .catch(err => {
            if (err.code === ErrorCodes_1.ErrorCodes.TOO_MANY_VALUATIONS) {
                const errorValuation = new TooManyValuationError_1.default(err.message);
                throw errorValuation;
            }
            throw this.errorTransformer.to(err);
        })
            .then(res => this.customerToRequestTransformer.from(res.data));
    }
    /**
     * @inheritDoc
     */
    update(customer, oldCustomer) {
        const url = Path_1.default.route(configs_js_1.configs.endpoints.customerUpdate, {
            id: customer.getId()
        });
        const currentData = this.customerToRequestTransformer.to(customer);
        const dataToSend = this.customerMergePatchConverter.convertCustomerToUpdateCustomerData(currentData, oldCustomer);
        return this.httpClient.patch(url, dataToSend)
            .catch(err => {
            if (err.code === ErrorCodes_1.ErrorCodes.TOO_MANY_VALUATIONS) {
                const errorValuation = new TooManyValuationError_1.default(err.message);
                throw errorValuation;
            }
            throw this.errorTransformer.to(err);
        })
            .then(res => this.customerToRequestTransformer.from(res.data));
    }
}
exports.default = CustomerRepository;
Mixin_1.default(CustomerRepository, IContainerInjection_1.default);
